import React, { PropTypes } from 'react';
import {StreamEventStatusType} from '../../../../api/stream/LiveStadiumStreamEvent';

class StreamStatus extends React.Component {
  static propTypes = {
    status: PropTypes.string.isRequired
  };

  static contextTypes = {
    muiTheme: PropTypes.object.isRequired
  };

  render() {
    let {muiTheme: {baseTheme: { palette: {accent1Color, greyColor}}}} = this.context;
    let {status} = this.props;

    switch (status) {
      // case StreamEventStatusType.active:
      // return (<span style={{color: accent1Color}}>Active</span>);
      // case StreamEventStatusType.pending:
      //   return (<span style={{color: greyColor}}>Waiting</span>);
      // case StreamEventStatusType.finished:
      //   return (<span>Finished</span>);
      // case StreamEventStatusType.draft:
      //   return (<span>Draft</span>);
      default:
        return (<span style={{ color: greyColor }}>{ status }</span>);
    }
  }
}

export default StreamStatus;





// WEBPACK FOOTER //
// ./src/components/Stream/LiveStream/StreamList/StreamStatus.js